module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_footer_inbound-965ddc40cd24642ee3d242d68af263ac.svg";